import { instrumentModuleGetter } from "next/dist/server/app-render/module-loading/instrument-module-getter";
const __TURBOPACK__icon__$23$0__ = instrumentModuleGetter(() => require(/*turbopackChunkingType: shared*/"METADATA_0"));
const __TURBOPACK__apple__$23$1__ = instrumentModuleGetter(() => require(/*turbopackChunkingType: shared*/"METADATA_1"));
const __TURBOPACK__openGraph__$23$2__ = instrumentModuleGetter(() => require(/*turbopackChunkingType: shared*/"METADATA_2"));
const __TURBOPACK__layout__$23$3__ = instrumentModuleGetter(() => require(/*turbopackChunkingType: shared*/"MODULE_3"));
const __TURBOPACK__error__$23$4__ = instrumentModuleGetter(() => require(/*turbopackChunkingType: shared*/"MODULE_4"));
const __TURBOPACK__not$2d$found__$23$5__ = instrumentModuleGetter(() => require(/*turbopackChunkingType: shared*/"MODULE_5"));
const __TURBOPACK__forbidden__$23$6__ = instrumentModuleGetter(() => require(/*turbopackChunkingType: shared*/"MODULE_6"));
const __TURBOPACK__unauthorized__$23$7__ = instrumentModuleGetter(() => require(/*turbopackChunkingType: shared*/"MODULE_7"));
const __TURBOPACK__global$2d$error__$23$8__ = instrumentModuleGetter(() => require(/*turbopackChunkingType: shared*/"MODULE_8"));
const __TURBOPACK__layout__$23$9__ = instrumentModuleGetter(() => require(/*turbopackChunkingType: shared*/"MODULE_9"));
const __TURBOPACK__template__$23$10__ = instrumentModuleGetter(() => require(/*turbopackChunkingType: shared*/"MODULE_10"));
const __TURBOPACK__not$2d$found__$23$11__ = instrumentModuleGetter(() => require(/*turbopackChunkingType: shared*/"MODULE_11"));
const __TURBOPACK__forbidden__$23$12__ = instrumentModuleGetter(() => require(/*turbopackChunkingType: shared*/"MODULE_12"));
const __TURBOPACK__unauthorized__$23$13__ = instrumentModuleGetter(() => require(/*turbopackChunkingType: shared*/"MODULE_13"));
const __TURBOPACK__page__$23$14__ = instrumentModuleGetter(() => require(/*turbopackChunkingType: shared*/"MODULE_14"));
import { createAppPageEntrypoint } from "next/dist/esm/build/templates/app-page-runtime";
import { interopDefault } from "next/dist/esm/server/app-render/interop-default" with {
    'turbopack-transition': 'next-server-utility'
};
const tree = ["", {
"children": ["(marketing)", {
"children": ["thank-you", {
"children": ["__PAGE__", {
}, {
  metadata: {  },  "page": [__TURBOPACK__page__$23$14__, "[project]/app/(marketing)/thank-you/page.tsx"],
}, []],
}, {
  metadata: {  },}, []],
}, {
  metadata: {  },  "layout": [__TURBOPACK__layout__$23$9__, "[project]/app/(marketing)/layout.tsx"],
  "template": [__TURBOPACK__template__$23$10__, "[project]/app/(marketing)/template.tsx"],
  "not-found": [__TURBOPACK__not$2d$found__$23$11__, "[project]/app/(marketing)/not-found.tsx"],
  "forbidden": [__TURBOPACK__forbidden__$23$12__, "[project]/node_modules/next/dist/client/components/builtin/forbidden.js"],
  "unauthorized": [__TURBOPACK__unauthorized__$23$13__, "[project]/node_modules/next/dist/client/components/builtin/unauthorized.js"],
}, []],
}, {
  metadata: {    icon: [
      (async () => {
        const mod = interopDefault(await __TURBOPACK__icon__$23$0__());
        return [{
          url: "/icon.png" + `?${mod.src.split("/").splice(-1)[0]}`,
          sizes: `${mod.width}x${mod.height}`,
          type: `image/png`,
        }];
      }),
    ],
    apple: [
      (async () => {
        const mod = interopDefault(await __TURBOPACK__apple__$23$1__());
        return [{
          url: "/apple-icon.png" + `?${mod.src.split("/").splice(-1)[0]}`,
          sizes: `${mod.width}x${mod.height}`,
          type: `image/png`,
        }];
      }),
    ],
    openGraph: [
      async (props) => interopDefault(await __TURBOPACK__openGraph__$23$2__())(props),
    ],
    manifest: "/manifest.webmanifest",
  },  "layout": [__TURBOPACK__layout__$23$3__, "[project]/app/layout.tsx"],
  "error": [__TURBOPACK__error__$23$4__, "[project]/app/error.tsx"],
  "not-found": [__TURBOPACK__not$2d$found__$23$5__, "[project]/app/not-found.tsx"],
  "forbidden": [__TURBOPACK__forbidden__$23$6__, "[project]/node_modules/next/dist/client/components/builtin/forbidden.js"],
  "unauthorized": [__TURBOPACK__unauthorized__$23$7__, "[project]/node_modules/next/dist/client/components/builtin/unauthorized.js"],
  "global-error": [__TURBOPACK__global$2d$error__$23$8__, "[project]/app/global-error.tsx"],
}, []]
const __next_app_require__ = __turbopack_context__.r.bind(__turbopack_context__)
const __next_app_load_chunk__ = __turbopack_context__.l.bind(__turbopack_context__)
const entrypoint = createAppPageEntrypoint({
    tree,
    page: "/(marketing)/thank-you/page",
    pathname: "/thank-you",
    require: __next_app_require__,
    loadChunk: __next_app_load_chunk__,
    interopDefault
});
export const __next_app__ = entrypoint.__next_app__;
export const routeModule = entrypoint.routeModule;
export const handler = entrypoint.handler;
export * from "next/dist/esm/server/app-render/entry-base" with {
    'turbopack-transition': 'next-server-utility'
};

//# sourceMappingURL=app-page.js.map
